import Smartlook from 'smartlook-client';

const sendEventToSmartLook = (eventName, dataProperties) => {
  Smartlook.track(eventName, dataProperties);
};

export const sendSmGlobalButtonClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmDoctorSpecialityClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmDoctorCardClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmFilterClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmSortBy = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmPaginationDoctors = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmViewDoctorDetails = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmDoctorDetailsTabClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmAppointModeChange = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmSlotSelection = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmChangeFacilityClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmSelectFacility = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmBeginCheckoutVc = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmBookAppointmentClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmAddPaymentInfoInitiated = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmAddPaymentInfoStatus = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmConfirmAppointment = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmCheckAppointmentDetailsClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmViewAppointmentDetails = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmCancelAppointment = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmRescheduleAppointment = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmRebookConsultationClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmBookFollowUpClick = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};
